import React, { FC, useCallback, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { Modal } from 'components/Modal'
import { Link } from 'react-router-dom'

import Button from '@mui/material/Button'
import { toast } from 'react-toastify'

import { socialLinks, staticMultimedia, TStaticMultimedia } from 'utils'

import styles from './styles.module.scss'

interface IProps {
  open: boolean,
  onClose: () => void,
}


const names = ['authencity', 'discord', 'twitter', 'instagram', 'telegram']
const filteredSocialLinks = socialLinks.filter(link => names.some(name => name === link.name))

export const ConfirmReserveModal: FC<IProps> = ({ open, onClose }) => {

  const onClickContinue = () => {
    onClose()
  }

  return (
    <Modal open={open}
           disableOutsideClick
           scroll={'paper'}
           buttonTitle={'Continue'}
           onClickButton={onClickContinue}
           buttonSX={{ maxWidth: '400px' }}
           contentSX={{ '&&': { paddingTop: '25px' } }}
    >
      <div className={styles.confirmModalContainer}>
        <div className={styles.title}>Thank you for reserving your spot for the Somnium VR1!</div>
        <div className={styles.description}>
          You will receive an email shortly to confirm your reservation. Thank you for joining the Somnium Space
          community!
          <br/><br/>
          To help us spread the word and grow our community, consider sharing this exciting news with your friends and
          followers on social media. Together, we can create an even more vibrant metaverse. Just click the buttons
          below to share!
        </div>
        <div className={styles.socialBox}>
          {filteredSocialLinks.map(item => (
            <Link to={item.link} target="_blank" rel="noopener noreferrer" key={item.name}>
              <img src={staticMultimedia[item.name as TStaticMultimedia]}
                   alt={item.name}
                   className={styles.socialIcon}/>
            </Link>
          ))}
        </div>
      </div>
    </Modal>
  )
}
